'use strict';

/* globals config, ajaxify, socket */

$(document).ready(function() {
	var listeners = {};
	var topicId;

	$(window).on('action:composer.loaded', function(ev, data) {
		topicId = data.composerData.tid;

		require(['composer', 'components'], function(composer, components) {
			components
				.get('composer')
				.find('.write')
				.focusout(removeTyping)
				.focus(setTyping);
		});
	});

	function setTyping() {
		socket.emit('plugins.typings.setTypings', { tid: topicId, userIsTyping: true });
	}

	function removeTyping() {
		socket.emit('plugins.typings.removeTyping', { tid: topicId });
	}

	$(window).on('action:ajaxify.end', function (event, data) {
		cleanListeners();

		if (data.tpl_url !== 'topic') {
			return;
		}

		var onTypingsReceived = function (data) {
			addTypingsUsers(data);
		}

		listeners[ajaxify.data.tid] = onTypingsReceived;
		socket.on('event:typings:' + ajaxify.data.tid, onTypingsReceived)
	});

	function cleanListeners() {
		for (var key in listeners) {
			if (listeners.hasOwnProperty(key)) {
				socket.removeListener('event:typings:' + key, listeners[key]);
			}
		}

		listeners = {};
	}

	function addTypingsUsers(typingsUser) {
		require(['benchpress', 'components'], function(Benchpress, components) {
			var usersListElement = components.get('typings-users');

			usersListElement.empty();
			for (var i = 0; i < typingsUser.length; i++) {
				var uid = typingsUser[i].uid;
				Benchpress.parse('partials/typings-user', typingsUser[i], function (html) {
					var user = $('[data-uid="' + uid  + '"]', usersListElement);

					if (user.length == 0) usersListElement.append(html);
					else user.replaceWith(html);
				});
			}
		});
	}
});